import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import * as API from "../api/index";
import { ROUTES } from "../../api/routes";
import FileTransferCommandViewTable from "./fileTransferCommandView";
import { commandColumns, COMMAND_FIELDS_TO_DELETE, toCommandRow } from "../shared/commandColumns";
import BackToolbarLink from "../shared/BackToolbarLink";
import AddToolbarLink from "../shared/AddToolbarLink";
import "../util/tables.css";

const FileCommands = () => {
  const [commandList, setCommandList] = useState([]);
  const navigate = useNavigate();
  const { transferID } = useParams();

  useEffect(() => {
    API.GetDataFromAPI(ROUTES.fileTransferCmds(transferID)).then((data) => {
      data.forEach((el) =>
        COMMAND_FIELDS_TO_DELETE.forEach((f) => delete el[f]),
      );
      setCommandList(data);
    });
  }, [transferID]);

  function getNextSeqNumber() {
    return Math.max(...commandList.map((cmd) => cmd.TRANSFER_SEQ), 0) + 1;
  }

  const dataParams = {
    transferID,
    transfer_seq: getNextSeqNumber(),
  };

  return (
    <div className="relative">

      {commandList.length > 0 ? (
        <FileTransferCommandViewTable
          data={commandList.map(toCommandRow)}
          columns={commandColumns}
          dataParams={dataParams}
        />
      ) : (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <BackToolbarLink onClick={() => navigate(-1)} />
          <AddToolbarLink to="/AddTransferCmd" label="Add Command" state={dataParams} />
        </Box>
      )}
    </div>
  );
};

export default FileCommands;
